import { ModelCommon, UserAttributeDef, UserAttributeDefs, toDatePickerFormat, ValidModelType } from '@iotv/datamodel-core';
import { isValidBusinessObject, MapLike, PathDirection } from '@iotv/iotv-v3-types';

const typeName = 'WaterTakeGroup';

export type WaterTakeGroupProps = {
  waterTakeStateByPeriod?: number;
  currentAggregateTakeFlowRate?: number;
  aggregateTakeVolumeLastPeriod?: number;
  changeFromPreviousPeriod?: number;
  aggregateTakeVolumeCurrentPeriod?: number;
  aggregateCumulativeTakeVolume?: number;
};

export class WaterTakeGroup extends ModelCommon {
  constructor(ob: any) {
    super(ob.type || typeName, ob);
  }

  waterTakeStateByPeriod?: number;
  currentAggregateTakeFlowRate?: number;
  aggregateTakeVolumeLastPeriod?: number;
  changeFromPreviousPeriod?: number;
  aggregateTakeVolumeCurrentPeriod?: number;
  aggregateCumulativeTakeVolume?: number;

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      waterTakeStateByPeriod: {
        type: 'Number',
        editable: true,
        label: 'Water Take State by Period',
        name: 'waterTakeStateByPeriod',
        description: 'Water Taken (or not) by Period for grouped Water Take objects',
      },
      currentAggregateTakeFlowRate: {
        type: 'Number',
        editable: true,
        label: 'Current Aggregate Take Flow Rate',
        name: 'currentAggregateTakeFlowRate',
        description: 'Current Flow Rate for grouped Water Take objects',
      },
      aggregateTakeVolumeLastPeriod: {
        type: 'Number',
        editable: true,
        label: 'Aggregate Take Volume Last Period',
        name: 'aggregateTakeVolumeLastPeriod',
        description: 'Aggregate water volume taken last period for grouped Water Take objects',
      },
      changeFromPreviousPeriod: {
        type: 'Number',
        editable: true,
        label: 'Change from previous period',
        name: 'changeFromPreviousPeriod',
        description: 'Change in take volume (l/m3/%) in last period to previous period(s)',
      },
      aggregateTakeVolumeCurrentPeriod: {
        type: 'Number',
        editable: true,
        label: 'Aggregate Take Volume Current Period',
        name: 'aggregateTakeVolumeCurrentPeriod',
        description: 'Aggregate water volume taken current period for grouped Water Take objects',
      },
      aggregateCumulativeTakeVolume: {
        type: 'Number',
        editable: true,
        label: 'Aggregate Cumulative Take Volume',
        name: 'aggregateCumulativeTakeVolume',
        description: 'Cumulative aggregate water volume taken for grouped Water Take objects',
      },
    };
  };
}
